import { FC, memo, useMemo } from 'react';
import { Pagination } from 'react-bootstrap';

import { paginator } from './helper';
import { PaginationProps } from './types';
import PaginationPopup from './PaginationPopup';

const Component: FC<PaginationProps> = memo((props) => {
    const links = [] as any,
        { hidePrevNextLinks = false, activePage = 1, itemsPerPage = 20, totalItems, onPageClick } = props,
        { currentPage, linkItems, totalPages } = useMemo(
            () => paginator(totalItems, activePage, itemsPerPage),
            [totalItems, activePage, itemsPerPage],
        );

    const onClickHandler = (page: number | '...') => () => page !== '...' && page !== currentPage && onPageClick(page);

    for (let i = 0; i <= linkItems.length; i++) {
        if (linkItems[i] === '...')
            links.push(
                <PaginationPopup
                    key={i}
                    prevPageNumber={linkItems[i - 1] as number}
                    nextPageNumber={linkItems[i + 1] as number}
                    onClickHandler={onPageClick}
                />,
            );
        else {
            linkItems[i] &&
                links.push(
                    <Pagination.Item key={i} onClick={onClickHandler(linkItems[i])} active={linkItems[i] === currentPage}>
                        {linkItems[i]}
                    </Pagination.Item>,
                );
        }
    }

    if (!hidePrevNextLinks) {
        links.unshift(<Pagination.Prev key="prev" disabled={currentPage < 2} onClick={onClickHandler(currentPage - 1)} />);
        links.unshift(<Pagination.First key="first" disabled={currentPage < 2} onClick={onClickHandler(1)} />);
        links.push(<Pagination.Next key="next" disabled={currentPage === totalPages} onClick={onClickHandler(currentPage + 1)} />);
        links.push(<Pagination.Last key="last" disabled={currentPage === totalPages} onClick={onClickHandler(totalPages)} />);
    }

    return <Pagination>{links}</Pagination>;
});

Component.displayName = 'Pagination';
export const DynamicPagination: FC<PaginationProps> = Object.assign(Component, {});
